// src/components/sections/StatsBar.jsx
// Teal gradient stats bar with animated counters

import React from 'react';
import useInView from '../../hooks/useInView';
import useCounter from '../../hooks/useCounter';

const StatItem = ({ value, suffix, label, isInView, delay }) => {
  const count = useCounter(value, isInView, 1500);

  return (
    <div
      className={`text-center transition-all duration-700 ${
        isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}
      style={{ transitionDelay: isInView ? `${delay}ms` : '0ms' }}
    >
      <p className="text-2xl md:text-4xl font-display font-bold text-white">
        {count}{suffix}
      </p>
      <p className="text-sm mt-1 text-white/70">{label}</p>
    </div>
  );
};

const STATS = [
  { value: 3, suffix: '', label: 'Products' },
  { value: 24, suffix: '/7', label: 'Real-time tracking' },
  { value: 100, suffix: '%', label: 'South African built' },
  { value: 15, suffix: '', label: 'Years Experience' },
];

const StatsBar = () => {
  const [ref, isInView] = useInView({ threshold: 0.3 });

  return (
    <section
      ref={ref}
      className="py-10 md:py-16 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #0d9488, #0f766e, #115e59)' }}
    >
      {/* Dot pattern overlay */}
      <div
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.3) 1px, transparent 0)',
          backgroundSize: '32px 32px',
        }}
      />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
          {STATS.map((stat, i) => (
            <StatItem
              key={i}
              value={stat.value}
              suffix={stat.suffix}
              label={stat.label}
              isInView={isInView}
              delay={i * 150}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;